import { registerGroup } from '@visactor/vrender-kits/register/register-group';
import { registerPath } from '@visactor/vrender-kits/register/register-path';

export function loadLinkPathComponent() {
  registerGroup();
  registerPath();
}
